define('CanonicalURL.EntryPoint', [
  'Facets.Browse.View',
  'underscore',
  'jQuery'
], function (
  FacetsBrowseView,
  _,
  jQuery
) {
  'use strict';

  function getBaseCanonicalUrl() {
    var url = new URL(window.location.href);

    var facetParams = [
      '?page=',
      'page',
      'part-type',
      'pricelevel5',
      'order',
      'show',
      'display',
      'seodebug',
      'preview'
    ];

    facetParams.forEach(function (p) {
      url.searchParams.delete(p);
    });

    return url.origin + url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '');
  }

  return {
    mountToApp: function mountToApp(container) {
      var plp = container.getComponent('PLP');
      _.extend(FacetsBrowseView.prototype, {
        getCanonical:  _.wrap(FacetsBrowseView.prototype.getCanonical, function (fn) {
          var result = fn.apply(this, _.toArray(arguments).slice(1));
          var newUrl = getBaseCanonicalUrl();
          if (newUrl) {
            return newUrl;
          }
          return result;
        })

      });


      if (plp) {
        plp.on('afterShowContent', function () {
          var canonicalTag = jQuery('link[rel="canonical"]');
          if (canonicalTag.length) {
            canonicalTag.attr('href', getBaseCanonicalUrl());
          } else {
            jQuery('<link>', {
              rel: 'canonical',
              href: getBaseCanonicalUrl()
            }).appendTo('head');
          }
        });
      }

    }
  };
});
